import React from 'react'
import ReactDOM from 'react-dom'
import { PropTypes } from 'prop-types'
import moment from 'moment'
import UniqId from 'uniqid'
import commaNumber from 'comma-number'
import i18n from '../../../i18n'
import './price_detail_component.scss'
import CurrencyHelper from '../../helpers/currency_helper'
import getSymbolFromCurrency from 'currency-symbol-map'
import { withNamespaces, Trans } from 'react-i18next'
import CouponHelper from '../../../common/helpers/coupon_helper'
import discountHelper from '../../helpers/discount_helper'

export class PriceDetail extends React.Component {
  constructor(prop) {
    super(prop)
    this.state = {
      isShowDetail: false,
      needScroll: false
    }
  }

  get currencySymbol() {
    if (this.props.payment_type && this.props.payment_type != '現地払い') {
      return getSymbolFromCurrency('JPY')
    }

    return this.props.prices.currency
      ? getSymbolFromCurrency(this.props.prices.currency)
      : CurrencyHelper.getCurrencySymbol(this.props.countryCode)
  }

  componentDidUpdate(prevProps) {
    if (this.props.prices.total_price != prevProps.prices.total_price) {
      this.decideDetailScroll()
    }
  }

  toggleShowDetail(e) {
    if (Object.keys(this.props.prices.dates).length == 0) {
      e.preventDefault()
    } else {
      this.setState({
        isShowDetail: !this.state.isShowDetail
      }, () => {
        this.decideDetailScroll()
      })
    }
  }

  decideDetailScroll() {
    if (this.state.isShowDetail) {
      setTimeout(() => {
        const threshold = window.innerWidth > 767 ? 995 : 395
        const dom = ReactDOM.findDOMNode(this.refs.breakdownInner)
        if(!dom) {
          // default to true if failed to find ref
          this.setState({ needScroll: true })
        } else {
          const actualHeight = dom.offsetHeight
          this.setState({ needScroll: actualHeight > threshold })
        }
      }, 500)
    } else {
      this.setState({ needScroll: false })
    }
  }

  detailText(date, roomNo) {
    const { t } = this.props
    const labels = { adults: t('price.adults'), children: t('price.children'), infants: t('price.infants') }
    let detail = []
    Object.keys(labels).map((key) => {
      if (date[key] > 0) {
        detail.push(<span key={UniqId()}><span>{labels[key]}</span><span className="notranslate">:</span><span className="notranslate">{date[key]}</span><span>{t('price.person')}</span></span>)
      }
    })

    if (this.props.prices.room_count > 0){
      return <span key={UniqId()}><span><span className="notranslate">{this.props.prices.room_count}</span>{t('price.room')}</span> <span>/</span> {detail}</span>
    }else{
      return <span key={UniqId()}><Trans i18nKey='price.room_count' count={roomNo}><span><span className="notranslate">{{count: roomNo}}</span>部屋目</span></Trans> <span>/</span> {detail}</span>
    }
  }

  get couponDetails() {
    if (this.props.prices.coupon_uses) {
      return this.props.prices.coupon_uses.map(({ coupon, discount_amount: amount }, i) => (
        amount > 0 && (
          <div styleName="price-expense-item" key={i}>
            <dt styleName="caption">
              {CouponHelper.translateName(coupon.title, languageHelper.pageLocale, '')}
              <small styleName="annotation">{this.props.couponAnnotation}</small>
            </dt>
            <dd className="notranslate">{this.currencySymbol} -{commaNumber(amount)}</dd>
          </div>
        )
      ))
    }
  }

  get additionalDiscounts() {
    if (this.props.prices.coupon_uses && this.props.showAdditionalDiscounts) {
      return this.props.prices.coupon_uses.map(({ additional_discounts: additionalDiscounts = [] }, i) => (
        <React.Fragment key={i}>
          {additionalDiscounts.map((discount, j) => (
            <div key={j}>
              (＋<strong className='notranslate'>{this.currencySymbol}{commaNumber(discount.amount)}</strong>
              { discountHelper.translateTitle(discount.title, 'price_detail') })
            </div>
          ))}
        </React.Fragment>
      ))
    }
  }

  get totalPrice() {
    if (this.props.prices.discount_by_coupon > 0) {
      const exponent = CurrencyHelper.getExponent(this.props.countryCode)
      return <React.Fragment>
        <strike>{this.currencySymbol}{commaNumber(this.props.prices.total_price)}</strike>
        {this.currencySymbol}{commaNumber((this.props.prices.total_price - this.props.prices.discount_by_coupon).toFixed(exponent))}
      </React.Fragment>
    } else {
      return <React.Fragment>{this.currencySymbol}{commaNumber(this.props.prices.total_price)}</React.Fragment>
    }
  }

  get totalPriceInSelectedCurrency() {
    var currencySymbol = CurrencyHelper.getSymbolFromSelectedCurrency()
    if (this.props.prices.selected_currency.discount_by_coupon > 0) {
      const exponent = CurrencyHelper.getExponentByCurrencyCode(CurrencyHelper.metaCurrencyCode())
      return <React.Fragment>
        <strike>{currencySymbol}{commaNumber(this.props.prices.selected_currency.total_price)}</strike>
        {currencySymbol}{commaNumber((this.props.prices.selected_currency.total_price - this.props.prices.selected_currency.discount_by_coupon).toFixed(exponent))}
      </React.Fragment>
    } else {
      return <React.Fragment>{currencySymbol}{commaNumber(this.props.prices.selected_currency.total_price)}</React.Fragment>
    }
  }

  get cancelFeeInSelectedCurrency() {
    return <React.Fragment>
      {CurrencyHelper.getSymbolFromSelectedCurrency()}{commaNumber(this.props.prices.selected_currency.cancel_fee)}
    </React.Fragment>
  }

  currencyExplantion() {
    if (this.isPayAtHotel) {
      return CurrencyHelper.currencyText(languageHelper.pageLocale, CurrencyHelper.getCurrencyCode(this.props.countryCode))
    }

    return CurrencyHelper.currencyText(languageHelper.pageLocale, 'JPY')
  }

  displaySelectedCurrency(calculating, isTotalPrice = true) {
    const { t } = this.props
    if (!this.isSameCurrency && this.props.prices.selected_currency) {
      var price = isTotalPrice ? this.totalPriceInSelectedCurrency : this.cancelFeeInSelectedCurrency
      return <React.Fragment>
        <div styleName="price-expense-item">
          <dt styleName="caption">{t('price.selected_currency_title', {code: CurrencyHelper.metaCurrencyCode()})}<span styleName="annotation">{t('price.ref_from')}</span></dt>
          <dd styleName="total-price" className="notranslate">{calculating ? this.calculatingString : price}</dd>
        </div>
      </React.Fragment>
    }
  }

  get isSameCurrency() {
    if (this.isPayAtHotel) {
      return CurrencyHelper.metaCurrencyCode() == CurrencyHelper.getCurrencyCode(this.props.countryCode)
    }

    return CurrencyHelper.metaCurrencyCode() === 'JPY'
  }

  get isPayAtHotel() {
    return this.props.payment_type == '現地払い' || this.props.isPayAtHotel
  }

  render() {
    const { calculating, prices, discount_rate: discountRate } = this.props
    const discounted = (prices.normal_accommodation_fee != prices.accommodation_fee) && (discountRate > 0)
    const { t } = this.props
    const explanationTrans = (this.isPayAtHotel) ? 'pay_at_hotel' : 'pay_with_creditcard'

    return (
      <React.Fragment>
        {!calculating &&
          <React.Fragment>
            <div styleName={`booking-price-summary${this.state.isShowDetail ? ' active' : ''}`}>
              <div styleName="price-summary-row">
                <div styleName="caption">{t('price.total_accomodation_price')}</div>
                <div styleName={`price-value${discounted ? ' discounted' : ''}`} className="notranslate">{this.currencySymbol}{commaNumber(discounted ? prices.normal_accommodation_fee : prices.accommodation_fee)}</div>
              </div>
              {discounted ? (
                <div styleName="price-summary-row price-summary-discount">
                  <div styleName="price-caption">
                    <span>{t('price.weekly_discount')}</span>
                    <span
                      styleName="annotation"
                      className="notranslate"
                    >
                        （{this.props.discount_rate}%）
                    </span>
                    <span>{t('price.discounted')}</span>
                  </div>
                  <div
                    styleName="price-value"
                    className="notranslate"
                  >
                    {this.currencySymbol}{commaNumber(this.props.prices.accommodation_fee)}
                  </div>
                </div>
              ) : null }
              <label styleName="accordion-trigger" htmlFor="priceDetail" onClick={this.toggleShowDetail.bind(this)}/>
            </div>
            <input styleName="accordion-switch" id="priceDetail" type="checkbox"/>
            <div styleName={`booking-price-breakdown${this.state.needScroll ? ' scroller' : ''}`}>
              <div styleName="price-breakdown-inner" ref="breakdownInner">
                <div styleName="caption">{t('price.room_price')}</div>
                <dl styleName="price-breakdown-daily">
                  {Object.keys(this.props.prices.dates).length > 0 &&
                  Object.keys(this.props.prices.dates).map((d) => {
                    const day = moment(d)
                    return (
                      <div styleName="price-breakdown-day" key={UniqId()}>
                        <dt>{day.format("YYYY/MM/DD")}</dt>
                        {this.props.prices.dates[d].map((date, index) => {
                          return(
                            <dd styleName="price-breakdown-day-detail" key={UniqId()}>
                              {this.detailText(date, index + 1)}
                              <span>{this.currencySymbol}{commaNumber(date.price)}</span>
                            </dd>
                          )
                        })}
                      </div>
                    )
                  })
                  }
                  { ((this.props.countryCode != 'jp' || this.props.countryCode == '') && this.currencySymbol == '¥') &&
                    <div styleName="price-breakdown-message">{ i18n.t('components:price_detail.price_breakdown_message') }</div>
                  }
                </dl>
              </div>
            </div>
            <dl styleName="booking-price-expenses">
              <div styleName="price-expense-item">
                <dt styleName="caption">{t('price.cleaning_fee')}</dt>
                <dd className="notranslate">{this.currencySymbol}{commaNumber(this.props.prices.cleaning_fee)}</dd>
              </div>
              <div styleName="price-expense-item">
                <dt styleName="caption">{t('price.service_fee')}</dt>
                <dd className="notranslate">{this.currencySymbol}{commaNumber(this.props.prices.service_fee)}</dd>
              </div>
              {this.couponDetails}
              {this.additionalDiscounts}
            </dl>
          </React.Fragment>
        }
        <dl styleName="booking-price-expenses">
          <div styleName="price-expense-item">
            <dt styleName="caption">{t('price.total_price')}<span styleName="annotation">{t('price.tax_included')}</span></dt>
            <dd styleName="total-price" className="notranslate">{calculating ? this.calculatingString : this.totalPrice}</dd>
          </div>
          { this.displaySelectedCurrency(calculating) }
        </dl>
        {this.props.prices.cancel_fee > 0 &&
          <dl styleName="booking-price-expenses">
            <div styleName="price-expense-item">
              <dt styleName="caption">{t('price.cancel_fee')}</dt>
              <dd styleName="cancel-fee">{this.currencySymbol}{commaNumber(this.props.prices.cancel_fee)}</dd>
            </div>
            { this.displaySelectedCurrency(calculating, false) }
          </dl>
        }
        { !this.isSameCurrency && this.props.prices.selected_currency &&
          <dl styleName="booking-price-expenses">
            <p>{t("price.currency_explanation." + explanationTrans, { currency_text: this.currencyExplantion() })}</p>
          </dl>
        }
      </React.Fragment>
    )
  }

  get calculatingString () {
    switch (languageHelper.pageLocale) {
    case 'en':
      return 'Calculating'
    default:
      return '計算中'
    }
  }
}

PriceDetail.propTypes = {
  prices: PropTypes.object.isRequired,
  discount_rate: PropTypes.number,
  calculating: PropTypes.bool,
  countryCode: PropTypes.string,
  currencySymbol: PropTypes.string,
  isPayAtHotel: PropTypes.bool
}

PriceDetail.defaultProps = {
  prices: {
    total_price: 0,
    service_fee: 0,
    consumption_tax: 0,
    cleaning_fee: 0,
    additional_person_fee: 0,
    accommodation_fee: 0,
    hotel_tax: 0,
    normal_accommodation_fee: 0,
    cancel_fee: 0,
    dates: {},
    room_count: 0,
    currency: ''
  },
  discount_rate: 0,
  calculating: false,
  countryCode: 'jp',
  currencySymbol: '¥',
  isPayAtHotel: false
}

export default withNamespaces('common')(PriceDetail)
